import * as depositActions from '../actions/Deposits';

const initialState = {
  deposits: [],
  offset: 0,
  limit: 10,
  totalCount: 7,
  depositAmountTotal: 0,
  amountTotal: 0,
  taxAmountTotal: 0,
  feeAmountTotal: 0,
  stripeFeeAmountTotal: 0,
  secretariatDepositAmountTotal: 0,
  depositStatuses: [
    {
      id: '',
      name: '選択なし'
    },
    {
      id: 'DEPOSITED',
      name: '入金済'
    },
    {
      id: 'UNDEPOSIT',
      name: '未入金'
    },
    {
      id: 'ERROR',
      name: 'エラー'
    }
  ],
  error: false,
  status: 200,
  error_message: ''
};

const deposits = (state = initialState, action) => {
  switch (action.type) {
    case depositActions.GET_DEPOSITS_SUCCESS:
      return Object.assign({}, state, action.payload);
    case depositActions.GET_DEPOSITS_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case depositActions.DOWNLOAD_DEPOSIT_SUCCESS:
      return Object.assign({}, state, action.payload);
    case depositActions.DOWNLOAD_DEPOSIT_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case depositActions.EDIT_DEPOSIT_REGISTER_SUCCESS:
      return Object.assign({}, state, { edit: action.payload });
    case depositActions.EDIT_DEPOSIT_REGISTER_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    default:
      return state;
  }
};

export default deposits;
